import { Injectable } from '@angular/core';
import { finalize, Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingIndicatorService {
  private subject = new Subject<boolean>();
  private loadingArray: boolean[] = [];

  get forcedLoadingState(): Observable<boolean> {
    return this.subject.asObservable();
  }

  forceLoadingState(isLoading: boolean): void {
    if (isLoading) {
      this.loadingArray.push(true);
    } else {
      const firstTrueLoadingIndex = this.loadingArray.indexOf(true);
      if (firstTrueLoadingIndex > -1) {
        this.loadingArray.splice(firstTrueLoadingIndex, 1);
      }
    }

    // If any are loading, state is still loading
    if (this.loadingArray.indexOf(true) > -1) {
      this.subject.next(true);
    } else {
      this.subject.next(false);
    }
  }

  getLoadingCount() {
    return this.loadingArray.filter((state) => state === true).length;
  }

  fromObservable<T>(obs$: Observable<T>) {
    this.forceLoadingState(true);
    return obs$.pipe(finalize(() => this.forceLoadingState(false)));
  }
}
